var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTableUser',{attrs:{"name":_vm.user ? _vm.user.full_name : '',"photo":_vm.user && _vm.user.crop ? _vm.user.crop.crop_url : ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }